import i18n from '@/i18n';
/**
 * Знак «Геліос Стратегія», зібраний на сітці знака «Геліос Агрегатор».
 *
 * ЧОМУ ВІН САМОРОБНИЙ. heliosstrategia.com закритий Cloudflare і на будь-який
 * запит віддає 403, тож файл їхнього логотипа взяти нема звідки. Натомість у
 * нас є логотип «Геліос Агрегатора» — а це той самий фірмовий стиль, де
 * відрізняється лише друге слово.
 *
 * ЯК ЗІБРАНО. Оригінальний файл — десять контурів: перший малює сонце й
 * велике HELIOS, решта дев'ять — по одному гліфу слова AGGREGATE. Перший
 * контур узято ДОСЛІВНО, дев'ять гліфів замінено текстовим рядком.
 *
 * ГЕОМЕТРІЯ не на око: межі старого слова обчислені розбором команд контуру —
 * x 362.4..729.1, базова лінія 403.0, висота великих літер 28.8. Нове слово
 * ставиться рівно туди, а textLength із lengthAdjust притискає його до тієї
 * самої ширини, тож блок лишається точка в точку тим самим.
 *
 * ІНЛАЙН, А НЕ ФАЙЛ: зовнішній .svg у теґу <img> не бачить шрифтів сторінки й
 * підставив би системний — слово поїхало б за накресленням. Усередині
 * документа працює Urbanist, той самий, що в усьому кабінеті.
 */
export default function HeliosStrategiaMark() {
  return (
    <svg viewBox="100 128 640 292" role="img" aria-label={i18n.t('ak_contacts_helios_strategia')}
      style={{ width: '100%', height: '100%' }}>
      <path fill="#CC181B" d="M168.55,334.77h12.39v-74.32h-12.39v30.97h-43.35v-30.97h-12.39v74.32h12.39v-30.97h43.35v30.97ZM596.66,297.95c0,13.66-11.11,24.77-24.78,24.77s-24.77-11.11-24.77-24.77,11.11-24.78,24.77-24.78,24.78,11.11,24.78,24.78M609.05,297.95c0-18.31-13.32-33.53-30.77-36.57-16.49-71.38-80.54-124.78-156.86-124.78s-140.3,53.33-156.84,124.66c-17.82,2.73-31.52,18.12-31.52,36.69s13.78,34.03,31.66,36.71c16.77,71,80.64,124.01,156.69,124.01,20.8,0,41.04-3.91,60.16-11.62l-4.63-11.49c-17.65,7.11-36.33,10.72-55.53,10.72-69.02,0-127.17-47.29-143.83-111.17h19.96v-12.39h-27.32c-11.64,0-21.41-8.08-24.05-18.92h48.24v-12.39h-48.07c2.88-10.49,12.48-18.24,23.87-18.24h27.32v-12.39h-20.13c16.43-64.19,74.76-111.8,144-111.8s127.92,47.89,144.16,112.38c-17.49,3.01-30.85,18.25-30.85,36.58,0,20.49,16.67,37.16,37.16,37.16s37.16-16.67,37.16-37.16M470.36,334.77h12.39v-74.32h-12.39v74.32ZM354.06,260.45v74.32h58.13v-12.39h-45.74v-61.93h-12.39ZM667.02,282.49c0-5.12,4.17-9.29,9.29-9.29h46.45v-12.39h-46.74v.02c-11.82.16-21.39,9.81-21.39,21.66s9.32,21.23,20.91,21.64v.04h31.86c5.12,0,9.29,4.17,9.29,9.29s-4.17,9.29-9.29,9.29h-46.58v12.39h46.88v-.02c11.81-.16,21.38-9.81,21.38-21.66s-9.38-21.3-21.04-21.65v-.03h-31.73c-5.12,0-9.29-4.17-9.29-9.29" />
      <text
        x="362.4"
        y="403"
        textLength="366.7"
        lengthAdjust="spacingAndGlyphs"
        fontFamily="Urbanist, Inter, sans-serif"
        fontSize="40"
        fontWeight={600}
      >
        STRATEGIA
      </text>
    </svg>
  );
}
